import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=e1b5404e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=e1b5404e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b5404e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1b5404e')) {
      api.createRecord('e1b5404e', component.options)
    } else {
      api.reload('e1b5404e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=e1b5404e&scoped=true&", function () {
      api.rerender('e1b5404e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2776JM2YTu8JG/JS/comp/SearchFilterTokens.vue"
export default component.exports